import { render, staticRenderFns } from "./Storage.vue?vue&type=template&id=72fd3a58&scoped=true"
import script from "./Storage.vue?vue&type=script&lang=js"
export * from "./Storage.vue?vue&type=script&lang=js"
import style0 from "./Storage.vue?vue&type=style&index=0&id=72fd3a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fd3a58",
  null
  
)

export default component.exports